import type { IContainer } from '@monofe/di';
import { injectOrBuildContainer } from '@monofe/di';
import TYPES from '../util/types';

export type ZipBinaryStorageType = ArrayBuffer | Blob;

export interface IZipEntryInfo {
    name: string;
    size: number;
    comment: string;
    lastModifiedDate: Date;
    isDirectory: boolean;
    encrypted: boolean;
    externalFileAttributes: number;
    versionMadeBy: number;
}

export interface IZip {
    unzipFile: <T extends ZipBinaryStorageType>(blobData: T, fileName: string) => Promise<T>;
    unzipAll: <T extends ZipBinaryStorageType>(blobData: T) => Promise<Record<string, T>>;
    listings: (blobData: ZipBinaryStorageType) => Promise<string[]>;
    fileInfo: <T extends ZipBinaryStorageType>(
        blobData: T,
        fileName: string,
    ) => Promise<IZipEntryInfo>;
}

export function injectZip(container: IContainer = injectOrBuildContainer()): IZip {
    return container.get<IZip>(TYPES.IZip);
}

export function bindZip(val: IZip, container: IContainer = injectOrBuildContainer()): void {
    container.bind<IZip>(TYPES.IZip, val);
}

export function unbindZip(container: IContainer = injectOrBuildContainer()): void {
    container.remove(TYPES.IZip);
}
